import React from 'react';
import { useNavigate } from 'react-router-dom';
import RateListPanel from '../../components/data_hub/RateListPanel';

const RateListPage = () => {
  const navigate = useNavigate();

  const handleViewDetails = (rate) => {
    navigate(`/data/rates/${rate.id}`);
  };

  return (
    <div className="p-8 h-screen flex flex-col bg-gray-50">
          {/* Header */}
          <div className="mb-6 flex-shrink-0">
            <h1 className="text-3xl font-bold text-gray-800 font-ui mb-2">Utility Rates Database</h1>
            <p className="text-gray-600 font-ui">Browse and search electricity rates from utilities across the US</p>
          </div>

          {/* Reusable Rate List Panel */}
          <div className="flex-1 overflow-hidden">
            <RateListPanel 
              onSelectRate={handleViewDetails}
              compact={false}
            />
          </div>
    </div>
  );
};

export default RateListPage;
